'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mobility_hub', {
      url: '/account/stationaccess/mobility_hub?jurisdiction&sta_recid',
      template: '<mobility-hub></mobility-hub>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null      // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/mobility_hub/mobility_hub.routes.js